<template>
  <v-dialog
    width="700"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="opened"
    @keydown.esc="$emit('update:opened', false)"
    lazy
  >
    <v-card flat v-if="currentQuestionnaire">
      <v-card-title class="title pb-0">
        <v-layout align-center>
          {{ $t('questionnaire.checklist') }}
          <v-spacer />
          <v-btn
            small
            :fab="$vuetify.breakpoint.xsOnly"
            flat
            class="white error--text text-capitalize ma-0"
            @click="$emit('update:opened', false)"
          >
            <v-icon class="mr-1" size="18"> clear </v-icon>
            {{ $vuetify.breakpoint.smAndUp ? 'Close' : '' }}
          </v-btn>
        </v-layout>
      </v-card-title>

      <v-card-text v-if="!checklistLoading">
        <v-alert
          v-if="!isEmpty(allDocumentsNeeded)"
          :value="true"
          outline
          block
          :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
          color="primary"
          class="text-xs-left"
        >
          {{ $t('questionnaire.checklistHelp') }}
        </v-alert>

        <v-layout
          v-if="isEmpty(allDocumentsNeeded)"
          class="my-3 darkgrey--text"
        >
          {{ $t('questionnaire.emptyAlert') }}
        </v-layout>
        <v-layout column v-else class="outlined mt-2 subheading">
          <v-layout
            v-for="question in allDocumentsNeeded"
            :key="question.id"
            row
            align-center
            class="mb-2"
          >
            <v-flex xs1>
              <v-icon
                v-if="
                  !isEmpty(question.answer) &&
                    question.answer !== 'Upload Later' &&
                    question.answer !== 'Answer Later'
                "
                color="green"
                >check_box</v-icon
              >
              <v-icon v-else>check_box_outline_blank</v-icon>
            </v-flex>
            <v-flex xs9 class="text-xs-left">
              <v-layout wrap class="font-weight-medium">
                <span v-if="!isEmpty(question.options)">{{
                  question.options.join(', ')
                }}</span>
                <span v-else>{{ question.text }}</span>
                <v-tooltip
                  class="ml-1"
                  bottom
                  v-if="question.follow_up_question_id"
                >
                  <span class="why-text primary--text" slot="activator"
                    >Why?</span
                  >
                  <span
                    v-html="formatReason(question, getParentQuestion(question))"
                  />
                </v-tooltip>
                <v-tooltip
                  class="ml-1"
                  bottom
                  v-else-if="question.section === 'Documents from Last Year'"
                >
                  <v-icon size="20" slot="activator">help_outline</v-icon>
                  <span>{{ $t('questionnaire.lastYearUpload') }}</span>
                </v-tooltip>
              </v-layout>
              <v-layout>
                <span
                  v-if="question.answer === 'Not Applicable'"
                  class="darkgrey--text body-1 ml-2"
                  >You marked Not Applicable</span
                >
                <span
                  v-else-if="
                    predefinedQuestionAnswers.includes(question.answer)
                  "
                  class="darkgrey--text body-1 ml-2"
                  >{{ question.answer }}{</span
                >
                <v-chip small v-else-if="!isEmpty(question.answer)"
                  >{{ listDocuments(question.answer).length }}
                  {{ $t('questionnaire.document')
                  }}{{ listDocuments(question.answer).length > 1 ? 's' : '' }}
                  {{ $t('questionnaire.uploaded')
                  }}{{ uploadLaterDate(question) }}</v-chip
                >
              </v-layout>
            </v-flex>
            <v-flex xs2 class="text-xs-left">
              <v-btn
                @click="$emit('upload', question)"
                class="ml-3 text-capitalize"
                small
                color="primary"
                :disabled="
                  selectedQuestion.id !== question.id &&
                    questionsUploadingDocs.includes(question.id)
                "
                :loading="
                  selectedQuestion.id === question.id &&
                    questionsUploadingDocs.includes(question.id)
                "
              >
                {{ $t('questionnaire.upload') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>

      <v-card-text v-else class="py-5">
        <v-progress-circular
          indeterminate
          size="25"
          color="primary"
        ></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { predefinedQuestionAnswers } from '@/constants/variables';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    currentQuestionnaire: {
      type: Object,
      default: null,
    },

    selectedQuestion: {
      type: Object,
    },

    questionsUploadingDocs: {
      type: Array,
    },

    allDocumentsNeeded: {
      type: Array,
    },

    checklistLoading: {
      type: Boolean,
    },
  },

  data() {
    return {
      predefinedQuestionAnswers,
    };
  },

  methods: {
    isEmpty,

    moment,

    listDocuments(answer) {
      return answer
        .split('&!&')
        .filter((item, index) => !(index === 0 && item === ''));
    },

    getParentQuestion(question) {
      return this.currentQuestionnaire.questionnaire_questions.find(
        q => q.id === question.follow_up_question_id,
      );
    },

    formatReason(question, parentQuestion) {
      return `You answered '${question.trigger_for_follow_up_question}' to '${parentQuestion.text}'`;
    },
    uploadLaterDate(question) {
      if (question.answer_by) {
        return ` (${moment(question.answer_by).format('ll')})`;
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.why-text {
  font-size: 12px;
}
</style>
